import React from "react";
import { FormattedMessage } from "react-intl";
import Accordion from "../../../components/Accordion/Accordion";
import { FREE_SHIPPING_THRESHOLD, SHIPPING_METHODS, formatPLN } from "../../../config/checkout";
import "./ShippingInfoPage.scss";

const bold = { b: (chunks) => <b>{chunks}</b> };
const priceOf = (id) => formatPLN(SHIPPING_METHODS.find((m) => m.id === id)?.price);

const ShippingInfoPage = () => {
    return (
        <div className="shipping-main">
            <header className="shipping-header">
                <h1 className="shipping-title"><FormattedMessage id="shipping_info_title" /></h1>
            </header>

            <section className="shipping-section">
                <h2 className="shipping-subtitle">
                    <span className="subtitle-bold"><FormattedMessage id="shipping_info_subtitle" /> </span>
                    <span className="subtitle-outline"><FormattedMessage id="shipping_info_country" /></span>
                </h2>
                <p className="shipping-desc">
                    <FormattedMessage id="shipping_info_dispatch" values={bold} /><br />
                    <FormattedMessage
                        id="shipping_info_free"
                        values={{ ...bold, amount: formatPLN(FREE_SHIPPING_THRESHOLD) }}
                    />
                </p>
            </section>

            <section className="accordion-list shipping-methods">
                <Accordion
                    title={<FormattedMessage id="shipping_dhl_courier_title" />}
                    icon={<img src="/img/logos/dhl.svg" alt="DHL" style={{ height: 20 }} loading="lazy" />}
                    defaultOpen
                >
                    <ul>
                        <li><FormattedMessage id="shipping_info_courier_payment" /></li>
                        <li><FormattedMessage id="shipping_info_price" values={{ ...bold, price: priceOf("dhl_courier") }} /></li>
                    </ul>
                </Accordion>

                <Accordion
                    title={<FormattedMessage id="shipping_dhl_cod_title" />}
                    icon={<img src="/img/logos/dhl.svg" alt="DHL" style={{ height: 20 }} loading="lazy" />}
                >
                    <ul>
                        <li><FormattedMessage id="payment_cod_note" /></li>
                        <li><FormattedMessage id="shipping_info_price" values={{ ...bold, price: priceOf("dhl_cod") }} /></li>
                    </ul>
                </Accordion>
            </section>

            <section className="shipping-additional">
                <Accordion title={<FormattedMessage id="shipping_info_more" />}>
                    <ul>
                        <li><FormattedMessage id="shipping_info_invoices" /></li>
                        <li><FormattedMessage id="shipping_info_poland_only" /></li>
                    </ul>
                </Accordion>
            </section>
        </div>
    );
};

export default ShippingInfoPage;
